import useBlProviders from '@/composables/providers/useBlProvider'
import ClustersDt from '@/services/dataTransferModules/clustersDt'

export default function useClusters() {
	const clustersDt = new ClustersDt()

	const defaults = {
		creatingCluster: {
			name: '',
			color: '',
		},
		fieldsToPatch: ['name', 'color'],
	}

	const {
		loadEntityFlags: flags,

		entities: fullFieldClusters,
		getEntities: getFullFieldClusters,

		extendedEntities: extendedFieldClusters,
		getExtendedEntities: getExtendedFieldClusters,

		basedEntities: basedFieldClusters,
		getBasedEntities: getBasedFieldClusters,

		hashedBasedEntities: hashedBasedClusters,
		getHashedBasedEntities: getHashedBasedClusters,

		entity: cluster,
		getEntity: getCluster,

		entityPopup: clusterPopup,
		getEntityPopup: getClusterPopup,

		entityPreview: clusterPreview,
		getEntityPreview: getClusterPreview,

		createEntity: createCluster,

		patchEntity: updateCluster,

		deleteEntity: deleteCluster,
	} = useBlProviders(
		clustersDt,
		Object.assign({
			showErrorNotificationForLoadingAllEntities: true,

			showErrorNotificationForCreatingEntity: true,

			showErrorNotificationForLoadingOneEntity: true,

			showErrorNotificationForUpdatingEntity: true,

			showErrorNotificationForDeletingEntity: true,
		})
	)

	return {
		flags,
		defaults,

		fullFieldClusters,
		basedFieldClusters,
		extendedFieldClusters,

		getBasedFieldClusters,
		getExtendedFieldClusters,
		getFullFieldClusters,

		cluster,
		clusterPopup,
		clusterPreview,
		getCluster,
		getClusterPopup,
		getClusterPreview,

		createCluster,
		updateCluster,
		deleteCluster,

		hashedBasedClusters,
		getHashedBasedClusters,
	}
}
